<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-[25px] mb-[25px]">
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content md:p-[10px] md:max-w-[500px]">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-[25px]">
          <div
            class="relative ltr:sm:mr-[45px] rtl:sm:ml-[45px] ltr:sm:border-r rtl:sm:border-l border-gray-100 dark:border-[#172036]"
          >
            <span
              class="inline-block text-gray-400 rounded-md py-[6.5px] px-[17.3px] border border-gray-100 dark:border-[#172036]"
            >
              Standard
            </span>
            <div
              class="font-medium text-black dark:text-white text-4xl mt-[15px] mb-[15px] md:mb-[25px] -tracking-[1px] leading-none"
            >
              $89<span class="font-normal tracking-normal text-xl">.99</span>
            </div>
            <p class="font-medium">For individual user</p>
            <button
              type="button"
              class="inline-block rounded-md font-medium transition-all md:text-md md:mt-[5px] py-[12px] px-[20px] text-white bg-primary-500 hover:bg-primary-400"
            >
              <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px]">
                <i
                  class="material-symbols-outlined !text-md absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
                >
                  arrow_forward_ios
                </i>
                Buy Now
              </span>
            </button>
            <div
              class="inline-block rounded-md bg-orange-600 text-white top-0 md:-top-[20px] ltr:right-0 ltr:md:-right-[35px] rtl:left-0 rtl:md:-left-[35px] py-[6px] px-[14px] absolute text-xs -rotate-[10.156deg]"
            >
              Most Popular
            </div>
          </div>
          <ul class="md:ltr:-ml-[25px] md:rtl:-mr-[25px]">
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Advanced Dashboard
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Task Management
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              File Storage (5GB)
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Email Integration
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Mobile App Access
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Custom Branding
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content md:p-[10px] md:max-w-[500px]">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-[25px]">
          <div
            class="relative ltr:sm:mr-[45px] rtl:sm:ml-[45px] ltr:sm:border-r rtl:sm:border-l border-gray-100 dark:border-[#172036]"
          >
            <span
              class="inline-block text-gray-400 rounded-md py-[6.5px] px-[17.3px] border border-gray-100 dark:border-[#172036]"
            >
              Premium
            </span>
            <div
              class="font-medium text-black dark:text-white text-4xl mt-[15px] mb-[15px] md:mb-[25px] -tracking-[1px] leading-none"
            >
              $119<span class="font-normal tracking-normal text-xl">.99</span>
            </div>
            <p class="font-medium">For team of 10 users</p>
            <button
              type="button"
              class="inline-block rounded-md font-medium transition-all md:text-md md:mt-[5px] py-[12px] px-[20px] text-white bg-primary-500 hover:bg-primary-400"
            >
              <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px]">
                <i
                  class="material-symbols-outlined !text-md absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
                >
                  arrow_forward_ios
                </i>
                Buy Now
              </span>
            </button>
          </div>
          <ul class="md:ltr:-ml-[25px] md:rtl:-mr-[25px]">
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Customizable Dashboard
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Task Management
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              File Storage (Unlimited)
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              Custom Reporting
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              24/7 Premium Support
            </li>
            <li
              class="relative ltr:pl-[30px] ltr:md:pl-[38px] rtl:pr-[30px] rtl:md:pr-[38px] mb-[15px] last:mb-0"
            >
              <i
                class="material-symbols-outlined text-success-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                check
              </i>
              White-label Solution
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-[25px] md:flex items-center justify-between">
    <h5 class="mb-0">Pricing Style - 2</h5>
  </div>

  <PricingStyleTwo />

  <!-- Breadcrumb -->
  <div class="mb-[25px] md:flex items-center justify-between">
    <h5 class="mb-0">Pricing Style - 3</h5>
  </div>

  <PricingStyleThree />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PricingStyleTwo from "./PricingStyleTwo.vue";
import PricingStyleThree from "./PricingStyleThree.vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Pricing",
  components: {
    PricingStyleTwo,
    PricingStyleThree,
  },
});
</script>
